module.exports = __webpack_public_path__ + "static/img/loading-icon.c67c881.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/loading-icon.png
// module id = 523
// module chunks = 3 4 5 6